import { resultCountStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryResultCount";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(resultCountStyles, {
    orderCountText: {
        forwardAs: "p",
        size: TYPOGRAPHY.size.smaller,
        css: css`
            margin-bottom: 14px;
        `,
    },
});
